import React, { useEffect, useRef } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import { Button } from '@/components/ui/button';
import { ArrowLeft } from 'lucide-react';
import { useToast } from '@/hooks/use-toast';

const Watch = () => {
  const { embedId } = useParams();
  const navigate = useNavigate();
  const { toast } = useToast();
  const iframeContainerRef = useRef<HTMLDivElement>(null);

  // Function to go back
  const handleGoBack = () => {
    navigate(-1);
  };

  // Function to request fullscreen
  const enterFullScreen = () => {
    if (iframeContainerRef.current) {
      if (iframeContainerRef.current.requestFullscreen) {
        iframeContainerRef.current.requestFullscreen().catch(err => {
          console.error('Error attempting to enable fullscreen:', err);
          toast({
            title: "Erro",
            description: "Não foi possível entrar em tela cheia",
            variant: "destructive",
          });
        });
      } else if ((iframeContainerRef.current as any).webkitRequestFullscreen) {
        (iframeContainerRef.current as any).webkitRequestFullscreen();
      } else if ((iframeContainerRef.current as any).msRequestFullscreen) {
        (iframeContainerRef.current as any).msRequestFullscreen();
      }
    }
  };

  useEffect(() => {
    // Small delay to ensure iframe is loaded
    const timer = setTimeout(() => {
      enterFullScreen();
    }, 1000);

    return () => clearTimeout(timer);
  }, [embedId]);

  if (!embedId) {
    toast({
      title: "Erro",
      description: "ID do vídeo não encontrado",
      variant: "destructive",
    });
    return <div className="flex justify-center items-center h-screen bg-[#141414]">
      <Button onClick={() => navigate('/')}>Voltar para Home</Button>
    </div>;
  }

  return (
    <div className="bg-[#141414] min-h-screen flex flex-col">
      <div className="p-4">
        <Button 
          variant="ghost" 
          className="text-white flex items-center gap-2 hover:bg-[#1e1e1e]"
          onClick={handleGoBack}
        >
          <ArrowLeft size={16} /> Voltar
        </Button>
      </div>
      
      <div className="flex-1 flex flex-col items-center justify-center p-4">
        <div className="w-full max-w-5xl">
          <div 
            ref={iframeContainerRef}
            style={{padding:'56.25% 0 0 0', position:'relative'}}
          >
            <iframe 
              src={`https://audtex-poc.xtream.tech/embed/${embedId}`} 
              frameBorder="0" 
              allow="autoplay; fullscreen; picture-in-picture; clipboard-write" 
              style={{position:'absolute', top:0, left:0, width:'100%', height:'100%'}} 
              title="Video Player"
            ></iframe>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Watch;